module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "orderViewcontainer",
    staticClass: "orderView-container common-container"
  }, [_c('el-row', {
    staticStyle: {
      "width": "100%",
      "height": "30px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "hzpbtn-primary",
    staticStyle: {
      "height": "35px",
      "line-height": "10px",
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.preStep
    }
  }, [_vm._v("返回到订单管理")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    staticStyle: {
      "height": "35px",
      "line-height": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    staticStyle: {
      "padding": "20px 0 0 0"
    },
    attrs: {
      "model": _vm.formData,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    on: {
      "change": _vm.collapseChange
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": '订单【' + _vm.formData.code + '】详情（点击' + _vm.orderColl + '）',
      "name": "coll"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "auto 10px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单编号",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "code", $$v)
      },
      expression: "formData.code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单日期",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.creattime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "creattime", $$v)
      },
      expression: "formData.creattime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "下单人",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.ordercareter),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ordercareter", $$v)
      },
      expression: "formData.ordercareter"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "培训公司",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.aagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "aagencyname", $$v)
      },
      expression: "formData.aagencyname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "销售公司",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.pagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "pagencyname", $$v)
      },
      expression: "formData.pagencyname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理1",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.cagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cagencyname", $$v)
      },
      expression: "formData.cagencyname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理2",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.tagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tagencyname", $$v)
      },
      expression: "formData.tagencyname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.consignee),
      callback: function($$v) {
        _vm.$set(_vm.formData, "consignee", $$v)
      },
      expression: "formData.consignee"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货电话",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.linkphone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "linkphone", $$v)
      },
      expression: "formData.linkphone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货地址",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.finaladdress),
      callback: function($$v) {
        _vm.$set(_vm.formData, "finaladdress", $$v)
      },
      expression: "formData.finaladdress"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "汇款人姓名",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.remittername),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remittername", $$v)
      },
      expression: "formData.remittername"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实际总金额",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.totalamount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "totalamount", $$v)
      },
      expression: "formData.totalamount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备    注",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单类型",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.ordertype),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ordertype", $$v)
      },
      expression: "formData.ordertype"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "促销标题",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.promotiontitle),
      callback: function($$v) {
        _vm.$set(_vm.formData, "promotiontitle", $$v)
      },
      expression: "formData.promotiontitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "U8ID",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.u8id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "u8id", $$v)
      },
      expression: "formData.u8id"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单状态",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.paystatus),
      callback: function($$v) {
        _vm.$set(_vm.formData, "paystatus", $$v)
      },
      expression: "formData.paystatus"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "运单号",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.waybillcode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "waybillcode", $$v)
      },
      expression: "formData.waybillcode"
    }
  })], 1)], 1), _vm._v(" "), (1 == 0) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  }, [(!!_vm.formData.waybillcode) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.checkWaybill
    }
  }, [_vm._v("查看物流 >")]) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "height": _vm.containerHeight - _vm.orderHeight,
      "highlight-current-row": "",
      "border": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stepname",
      "label": "促销类别",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spcode",
      "label": "商品编号",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spname",
      "label": "商品名称",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spccomunitname",
      "label": "单位",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spsize",
      "label": "数量",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spmoney",
      "label": "单价(元)",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spamount",
      "label": "合计(元)",
      "formatter": _vm.formatAmount,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zpcode",
      "label": "是否赠品",
      "formatter": _vm.formatType,
      "align": "center",
      "width": "100"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": '运单号',
      "visible": _vm.wayBillDialogVisible,
      "width": "700px"
    },
    on: {
      "update:visible": function($event) {
        _vm.wayBillDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('section', {
    staticClass: "wbsec"
  }, _vm._l((_vm.wayBillDatas), function(wb) {
    return _c('el-tag', {
      key: wb,
      staticClass: "wbtag",
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.clickWayBill(wb)
        }
      }
    }, [_vm._v(_vm._s(wb) + " "), _c('i', {
      staticClass: "el-icon-aim"
    })])
  }), 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": '物流信息',
      "visible": _vm.logisticsDialogVisible,
      "width": "700px",
      "height": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.logisticsDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('section', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('label', {
    staticClass: "billNo"
  }, [_vm._v("运单号：" + _vm._s(_vm.logisticsBillNo))]), _vm._v(" "), _c('label', {
    staticClass: "billState"
  }, [_vm._v(_vm._s(_vm.logisticsStatu))]), _vm._v(" "), _c('section', {
    staticClass: "billContent"
  }, [_c('ul', {
    staticClass: "bcul"
  }, _vm._l((_vm.logisticsDatas), function(lo, index) {
    return _c('li', {
      key: lo.operatetime,
      staticClass: "bcli",
      style: (index == 0 ? 'color: #E3A53F;' : '')
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('span', {
      staticClass: "el-icon-location"
    })]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.formatTitle(lo.date, lo.time)))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', {
      staticClass: "bccon",
      domProps: {
        "innerHTML": _vm._s(lo.content)
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(lo.content) + "\n\t\t\t\t\t\t\t\t\t")])])], 1)], 1)
  }), 0)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5957aff2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/orderManagement/OrderView.vue
// module id = 712
// module chunks = 1